import styled from 'styled-components';
import Button from '../../Button/Button';
import { mediaBelow } from '../../../assets/styles/helper';
import { variables } from '../../../assets/styles/variables';

// Shared Sell-From-Home secondary CTA (outlined). Pins the primaryOutlined
// variant and the SFH 16px type spec so it stays consistent with
// SfhPrimaryButton across every screen. `&&` outranks Button's base +
// mediaBelow(bpMd) font-size rules so 16px holds at every breakpoint.
// Variant colors come from themeColors tokens — do not hardcode them here.
const SfhSecondaryButton = styled(Button).attrs({
  variant: 'primaryOutlined',
  textTransform: 'none',
})`
  && {
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
  ${mediaBelow(variables.breakpoints.bpMd)} {
    height: 44px;
  }
`;

export default SfhSecondaryButton;
